export default __webpack_public_path__ + "static/media/SC42.f996c318.mp4";